import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({

    widgetContainer: {
        paddingBottom: '24px',
    },

    page: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      height: '100vh',
    },

    content: {
        display: 'flex',
        flexDirection: 'column',
        width: '400px',
        backgroundColor: '#FFFFFF',
    },

    listHeader: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '400px',
        backgroundColor: '#FFFFFF',
    },

    nameCell: {
        width: '140px',
        fontSize: '14px',
    },

    textCell: {
        width: '50%',
        fontSize: '14px',
    },

    text: {
        fontSize: '12px !important',
        padding: '4px',
    },

    actionCell: {
        width: '100px',
        justifyContent: 'flex-start',
        alignItems: 'center',
    },

    actionCellIcon: {
        padding: '4px',
        margin: '4px',
    },

    tableTitle: {
        size: 'medium',
    },

    deleteIcon: {
        display: 'flex',
        width: '24px',
        height: '24px',
    },

    tablePagination: {
        display: 'flex',
        width: '100%',
        justifyContent: 'flex-end',
    },

});

export default styles;
export const useStyles = makeStyles(styles);
